import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import React from 'react';

export enum UserType {
    LANDLORD = 'LANDLORD',
    TENANT = 'TENANT',
    VENDOR = 'VENDOR',
    PROPERTY_MANAGER = 'PROPERTY_MANAGER'
}

interface AppState {
    userType: UserType | null;
    setUserType: (type: UserType | null) => void;
    isAuthenticated: boolean;
    setAuthenticated: (status: boolean) => void;
    logout: () => void;
}

export const useStore = create<AppState>()(
    persist(
        (set) => ({
            userType: null,
            setUserType: (type) => set({ userType: type }),
            isAuthenticated: false,
            setAuthenticated: (status) => set({ isAuthenticated: status }),
            logout: () => {
                set({ userType: null, isAuthenticated: false });
                window.location.href = '/login';
                window.history.pushState("", "", "/");
                window.history.go(0);
            },
        }),
        {
            name: 'cribly-app-storage',
            storage: createJSONStorage(() => localStorage),
        }
    )
);

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
    return <>{children}</>;
};